import { Flex, Text } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

const NavigationButtons = ({ onNext, onBack }) => {
  return (
    <Flex
      position="fixed"
      bottom="100px"
      left="0"
      right="0"
      width="100%"
      justify="space-between"
      padding="0 50px"
    >
      {/* Back Button */}
      <Flex align="center" cursor="pointer" onClick={onBack}>
        <ChevronLeftIcon w={12} h={12} color="#10b981" />
        <Text style = {{font:'Inter', fontSize: '16px'}}>Back</Text>
      </Flex>

      {/* Next Button */}
      <Flex align="center"  cursor="pointer" onClick={onNext}>
        <Text style = {{font:'Inter', fontSize: '16px',}}>Next</Text>
        <ChevronRightIcon w={12} h={12} color="#10b981" />
      </Flex>
    </Flex>
  );
};

export default NavigationButtons;
